module.exports = __webpack_public_path__ + "media/images/amicoboutiq-ac728910f7ad4fcc3a32e9867d3824d6.svg";